import { GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILED, PRODUCTS_CONVERSIONS_BEFORE } from '../../actions/product/get-products'
import { GET_MERCHANT_PRODUCTS_SUCCESS, GET_MERCHANT_PRODUCTS_FAILED, GET_MERCHANT_PRODUCTS_REQUEST } from '../../actions/superadmin/merchant/get-merchant-products'
import { LOGOUT_SUCCESS, LOGOUT_FAILED, LOGOUT_REQUEST, IMPERSONATE_END } from '../../actions/logout'
import { LOGIN_CHECK_FAILED, LOGIN_REQUEST } from '../../actions/loginActions'
import { IMPERSONATE_END_CLEAR, IMPERSONATE_SUCCESS } from '../../actions/impersonate'
import { PUBLISH_PRODUCT_SUCCESS, PUBLISH_PRODUCT_FAILED, PUBLISH_PRODUCT_REQUEST } from "../../actions/product/publish-product"
import { UNPUBLISH_PRODUCT_SUCCESS, UNPUBLISH_PRODUCT_FAILED, UNPUBLISH_PRODUCT_REQUEST } from "../../actions/product/unpublish-product"
import { DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_FAILED, DELETE_PRODUCT_REQUEST, DELETE_PRODUCT_MODAL_CLOSE, DELETE_PRODUCT_MODAL_OPEN } from '../../actions/product/delete-product'
import { TOGGLE_CTA_SUCCESS, TOGGLE_CTA_FAILED, TOGGLE_CTA_REQUEST } from '../../actions/product/toggle-cta'
import { GET_PRODUCT_SUCCESS } from '../../actions/product/get-product'
import { TOGGLE_NOTIFICATION_FAILED, TOGGLE_NOTIFICATION_REQUEST } from '../../actions/notification/update-notification';
import { PRODUCTS_PAGINATE_DATA_CHANGE } from '../../actions/product/paginate-data';

const initialState = {
  all: [],
  merchantProducts: [],
  requestingDomainConstantProducts: false,
  requesting: false,
  error: null,
  errorCategoryProducts: null,
  requestingCategoryProducts: false,
  productPaginateData: {
    sortByIndex: 0,
    filterByIndex: 0,
    currentPage: 0,
    query: ""
  },
  conversionsBefore: null
}
export const products = (state = initialState, action) => {

  switch (action.type) {
    case LOGIN_CHECK_FAILED:
    case LOGIN_REQUEST:
    case IMPERSONATE_END:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAILED:
    case LOGOUT_REQUEST:
    case IMPERSONATE_END_CLEAR:
    case IMPERSONATE_SUCCESS:
      return {
        ...state,
        all: [],
        merchantProducts: [],
        requesting: false,
        requestingCategoryProducts: false,
        requestingDomainConstantProducts: false,
        error: null
      }

    case UNPUBLISH_PRODUCT_FAILED:
    case PUBLISH_PRODUCT_FAILED:
    case TOGGLE_CTA_FAILED:
    case TOGGLE_NOTIFICATION_FAILED:
    case DELETE_PRODUCT_FAILED:
      return {
        ...state,
        error: action.error,
        requesting: false,
        confirmDeleteModalOpen: false,
        toDeleteProductId: null
      }

    case UNPUBLISH_PRODUCT_REQUEST:
    case PUBLISH_PRODUCT_REQUEST:
    case TOGGLE_CTA_REQUEST:
    case TOGGLE_NOTIFICATION_REQUEST:
    case DELETE_PRODUCT_REQUEST:
      return {
        ...state,
        error: null,
        requesting: true
      }
    case GET_PRODUCTS_REQUEST:
      return Object.assign({}, state, {
        requesting: true,
        error: null
      })
    case GET_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        requesting: false,
        searching: false,
        all: action.payload.data.payload,
        error: null
      })
    case GET_PRODUCTS_FAILED:
      return Object.assign({}, state, {
        all: [],
        requesting: false,
        error: action.error
      })
    case GET_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        all: state.all.map((product) => {
          if (action.payload.data.payload._id === product._id) {
            return Object.assign({}, product, action.payload.data.payload)
          }
          return product
        }),
        merchantProducts: state.merchantProducts.map((product) => {
          if (action.payload.data.payload._id === product._id) {
            return Object.assign({}, product, action.payload.data.payload)
          }
          return product
        })
      })
    case GET_MERCHANT_PRODUCTS_REQUEST:
      return Object.assign({}, state, {
        requesting: true,
        error: null
      })
    case GET_MERCHANT_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        merchantProducts: action.payload.data.payload,
        requesting: false,
        error: null,
      })
    case GET_MERCHANT_PRODUCTS_FAILED:
      return Object.assign({}, state, {
        requesting: false,
        error: action.error
      })
    case PUBLISH_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        requesting: false,
        all: state.all.map((product) => {
          if (action.payload.data.payload._id === product._id) {
            return Object.assign({}, product, {
              published: action.payload.data.payload.published,
              publishedAt: action.payload.data.payload.publishedAt
            })
          }
          return product
        }),
        merchantProducts: state.merchantProducts.map((product) => {
          if (action.payload.data.payload._id === product._id) {
            return Object.assign({}, product, {
              published: action.payload.data.payload.published,
              publishedAt: action.payload.data.payload.publishedAt
            })
          }
          return product
        })
      })
    case UNPUBLISH_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        requesting: false,
        all: state.all.map((product) => {
          if (action.payload.data.payload._id === product._id) {
            return Object.assign({}, product, { published: action.payload.data.payload.published })
          }
          return product
        }),
        merchantProducts: state.merchantProducts.map((product) => {
          if (action.payload.data.payload._id === product._id) {
            return Object.assign({}, product, { published: action.payload.data.payload.published })
          }
          return product
        }),
      })
    case TOGGLE_CTA_SUCCESS:
      const { allowDownload, allowFavourite, allowShare, featured } = action.payload.data.payload;
      return Object.assign({}, state, {
        error: null,
        requesting: false,
        all: state.all.map((product) => {
          if (product._id === action.payload.data.payload._id) {
            return Object.assign({}, product, { allowDownload, allowShare, allowFavourite, featured })
          }
          return product
        }),
        merchantProducts: state.merchantProducts.map((product) => {
          if (product._id === action.payload.data.payload._id) {
            return Object.assign({}, product, { allowDownload, allowShare, allowFavourite, featured })
          }
          return product
        }),
      })
    case DELETE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        requesting: false,
        all: state.all.filter(product => product._id !== action.payload.data.payload._id),
        merchantProducts: state.merchantProducts.filter(product => product._id !== action.payload.data.payload._id),
        confirmDeleteModalOpen: false,
        toDeleteProductId: null
      })
    case PRODUCTS_PAGINATE_DATA_CHANGE:
      return Object.assign({}, state, {
        productPaginateData: Object.assign(state.productPaginateData, action.payload)
      })
    case PRODUCTS_CONVERSIONS_BEFORE:
      return Object.assign({}, state, {
        conversionsBefore: action.payload
      })
    case DELETE_PRODUCT_MODAL_OPEN:
    case DELETE_PRODUCT_MODAL_CLOSE:
      return Object.assign({}, state, action.payload);
    default:
      return state
  }
}

export default products;



// WEBPACK FOOTER //
// ./src/redux/reducers/product/products.js